import { filterXSS, IFilterXSSOptions } from 'xss'

export function removeUnsafeElements(html: string): string {
  const options: IFilterXSSOptions = {
    whiteList: {
      tr: ['class'],
      th: ['class'],
      td: ['title', 'style', 'class', 'colspan'],
      div: [],
      b: [],
      a: ['href', 'onclick'],
      table: ['border', 'id'],
      form: ['method', 'style', 'class'],
      select: ['name', 'onchange'],
      option: ['name', 'value', 'selected'],
      input: ['type', 'name', 'class', 'placeholder', 'value'],
      style: [],
      br: []
    }
  }

  return filterXSS(html, options)
}
